/**
 * Paleta de cores semânticas compartilhadas entre os helpers de status.
 * Centraliza as cores usadas nos badges/células de status em toda a aplicação.
 */

export const STATUS_COLOR_PALETTE = {
    green: '#38a169',
    yellow: '#ddc120d6',
    red: '#ff1e1eff',
    orange: '#f39a1cff',
    grey: '#868d99ff',
    blue: '#3182ceff',
    default: '#a0aec0',
};
